export const ENGLISH_IQ_EVENTS = {
  dailyTargetSelected: 'english_iq_daily_target',
  demoComplete: 'english_iq_demo_complete',
  demoStart: 'english_iq_demo_start',
  entry: 'english_iq_entry',
  friendResultViewed: 'english_iq_friend_result_view',
  historyViewed: 'english_iq_history_viewed',
  itemPresented: 'english_iq_item_presented',
  testStart: 'english_iq_start',
  itemAnswered: 'english_iq_item_answered',
  mediaFailure: 'english_iq_media_failure',
  milestone: 'english_iq_milestone',
  progressViewed: 'english_iq_progress_viewed',
  recipientComplete: 'english_iq_recipient_complete',
  recipientStart: 'english_iq_recipient_start',
  resultClaimed: 'english_iq_result_claimed',
  resultRevealed: 'english_iq_result_revealed',
  testComplete: 'english_iq_complete',
  resultViewed: 'english_iq_result_viewed',
  shareSheetOpened: 'english_iq_share_sheet_open',
  shareSuccessful: 'english_iq_share_success',
  shareTap: 'english_iq_share_tap',
  skillCheckComplete: 'english_iq_skill_complete',
  skillCheckStart: 'english_iq_skill_start',
  storeOpen: 'english_iq_store_open',
  installCta: 'english_iq_install_cta',
} as const;

export type EnglishIqEventNameType = (typeof ENGLISH_IQ_EVENTS)[keyof typeof ENGLISH_IQ_EVENTS];
